module.exports = __webpack_public_path__ + "static/media/optionViewActive.38389e92.svg";